import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { CompareProvider } from "./context/CompareContext";
import { LikesProvider } from "./context/LikesContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Schools from "./pages/Schools";
import SchoolDetail from "./pages/SchoolDetail";
import Match from "./pages/Match";
import Compare from "./pages/Compare";
import Tentang from "./pages/Tentang";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import SchoolRegistration from "./pages/SchoolRegistration";
import ParentRegistration from "./pages/ParentRegistration";
import ParentDashboard from "./pages/ParentDashboard";
import SchoolDashboard from "./pages/SchoolDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  const { pathname } = useLocation();
  const isFocusedAuth =
    pathname.startsWith("/daftar/") || pathname === "/login" || pathname.startsWith("/dashboard/");

  return (
    <CompareProvider>
      <LikesProvider>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-cream">
          {!isFocusedAuth ? <Navbar /> : null}
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/schools" element={<Schools />} />
              <Route path="/schools/:slug" element={<SchoolDetail />} />
              <Route path="/match" element={<Match />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/tentang" element={<Tentang />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/daftar/sekolah" element={<SchoolRegistration />} />
              <Route path="/daftar/orang-tua" element={<ParentRegistration />} />
              <Route path="/dashboard/orang-tua/*" element={<ParentDashboard />} />
              <Route path="/dashboard/sekolah/*" element={<SchoolDashboard />} />
              <Route path="*" element={<Landing />} />
            </Routes>
          </main>
          {!isFocusedAuth ? <Footer /> : null}
        </div>
      </LikesProvider>
    </CompareProvider>
  );
}
